<template>
  <div v-if="$store.state.auth.user != null">
    <div class="grid grid-cols-12 gap-6 mt-5">
      <div class="intro-y col-span-12 lg:col-span-12">
        <!-- BEGIN: Bordered Table -->
        <div class="intro-y box mt-5">
          <div
            class="flex flex-col lg:flex-row items-center p-5 border-b border-gray-200"
          >
            <h2
              v-if="$store.state.auth.user.isAdmin == 0"
              class="font-medium text-base"
            >
              {{ this.$store.state.auth.user.agencyName }}
            </h2>
            <select
              v-if="$store.state.auth.user.isAdmin >= 1"
              v-model="agencyId"
              type="text"
              class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0"
              @change="getTransactions()"
            >
              <option value="">전체</option>
              <option
                v-for="(agency, index) in agencies"
                :key="index"
                :value="agency.id"
              >
                <h2 class="font-medium text-base mr-auto">
                  {{ agency.name }}
                </h2>
              </option>
            </select>
            <select
              v-model="moneyCategoryCode"
              type="text"
              class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0 lg:ml-4"
              @change="getTransactions()"
            >
              <option value="">전체</option>
              <option
                v-for="(moneyCategory, index) in $store.state.main
                  .moneyCategories"
                :key="index"
                :value="moneyCategory.code"
              >
                <h2 class="font-medium text-base mr-auto">
                  {{ moneyCategory.name }}
                </h2>
              </option>
            </select>
            <select
              v-model="adminName"
              type="text"
              class="input input--lg border w-full lg:w-auto mt-3 lg:mt-0 lg:ml-4"
              @change="onChangeAdmin($event)"
            >
              <option value="">전체</option>
              <option
                v-for="(adminItem, index) in localAdmins"
                :key="index"
                :value="adminItem.id"
              >
                <h2 class="font-medium text-base mr-auto">
                  {{ adminItem.username }}
                </h2>
              </option>
            </select>
            <div id="test_click_btn" @click="getTransactions()"></div>
            <button
              v-if="
                $store.state.auth.user.isAdmin >= 1 && isQuickRangeAllowed(7)
              "
              class="flex button w-full lg:w-24 mt-3 lg:mt-0 lg:ml-5 lg:mr-1 inline-block border border-theme-1 text-theme-1 dark:border-theme-10 dark:text-theme-10"
              @click="calcOneWeek()"
            >
              1주일
            </button>
            <button
              v-if="
                $store.state.auth.user.isAdmin >= 1 && isQuickRangeAllowed(30)
              "
              class="flex button w-full lg:w-24 mt-3 lg:mt-0 lg:mr-1 inline-block border border-theme-9 text-theme-9 dark:border-theme-9"
              @click="calcOneMonth()"
            >
              1개월
            </button>
            <button
              v-if="
                $store.state.auth.user.isAdmin >= 1 && isQuickRangeAllowed(92)
              "
              class="flex button w-full lg:w-24 mt-3 lg:mt-0 lg:mr-1 inline-block border border-theme-12 text-theme-12 dark:border-theme-12"
              @click="calcThreeMonth()"
            >
              3개월
            </button>
            <button
              v-if="
                $store.state.auth.user.isAdmin >= 1 && isQuickRangeAllowed(184)
              "
              class="flex button w-full lg:w-24 mt-3 lg:mt-0 lg:mr-5 inline-block border border-theme-6 text-theme-6 dark:border-theme-6"
              @click="calcSixMonth()"
            >
              6개월
            </button>
            <div class="w-full flex items-center justify-between">
              <el-date-picker
                v-if="$store.state.auth.user.isAdmin >= 1"
                v-model="listQuery.dateRange"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="~"
                start-placeholder="시작날짜"
                end-placeholder="마지막날짜"
                value-format="yyyy-MM-dd"
                :picker-options="deletedPeriodPickerOptions"
                class="flex inline-block mt-3 lg:mt-0"
                @change="onChangeDay"
              >
              </el-date-picker>
              <div class="flex items-center lg:ml-auto mt-3 mt-5 lg:mt-2">
              <button
                class="w-10 h-10 opacity-0 cursor-pointer"
                @click="exportUniqueExcel()"
              ></button>

                <button
                  class="button w-24 mr-1 mb-2 bg-theme-12 text-white"
                  @click="exportExcel()"
                >
                  엑셀출력
                </button>
              </div>
            </div>
          </div>
          <div id="bordered-table" class="p-5">
            <div class="preview">
              <div class="overflow-x-auto">
                <table class="table">
                  <thead>
                    <tr>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        순번
                      </th>
                      <th
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        지점이름
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        날짜
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        시간
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        이름
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        국적
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        구분
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        실명번호
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                        style="width: 500px !important;padding: 0px !important;"
                      >
                        <div class="text-center py-1">
                          매입통화
                        </div>
                        <div class="flex-container">
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            미국
                          </div>
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            일본
                          </div>
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            대만
                          </div>
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            중국
                          </div>
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            유럽
                          </div>
                          <div
                            class="border dark:border-dark-5 whitespace-no-wrap text-center py-1"
                          >
                            기타
                          </div>
                        </div>
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        환율
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        총액
                      </th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        제외
                      </th>
                      <th
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      ></th>
                      <th
                        class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                      >
                        담당자
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(transaction, index) in transactions"
                      :key="index"
                    >
                      <td class="border dark:border-dark-5 text-center">
                        {{ (listQuery.page - 1) * listQuery.limit + index + 1 }}
                      </td>
                      <td
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border dark:border-dark-5 text-center"
                      >
                        {{
                          $h.findItemFromArray(
                            agencies,
                            transaction.agencyId
                          )[0].name
                        }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        {{ $h.formatDate(transaction.createdAt, "MM/DD") }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        {{ $h.formatDate(transaction.createdAt, "HH:mm") }}
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <div v-if="transaction.user.name == ''">
                          # # # # # #
                        </div>
                        <div v-else>
                          {{ transaction.user.name }}
                        </div>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <div v-if="transaction.user.nationality == ''">
                          # # # # # #
                        </div>
                        <div v-else>
                          {{ transaction.user.nationality }}
                        </div>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <template v-if="transaction.user.noType != null">
                          0{{ transaction.user.noType }}
                        </template>
                        <template v-else>
                          # #
                        </template>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <template v-if="transaction.user.noType == null">
                          # # # # # #
                        </template>
                        <template v-else-if="transaction.user.noType == 1">
                          <div v-if="$h.isEmpty(transaction.user.residenceNo)">
                            # # # # # #
                          </div>
                          <div v-else>
                            {{ transaction.user.residenceNo }}
                          </div>
                        </template>
                        <template v-else-if="transaction.user.noType == 2">
                          <div v-if="$h.isEmpty(transaction.user.passportNo)">
                            # # # # # #
                          </div>
                          <div v-else>
                            {{ transaction.user.passportNo }}
                          </div>
                        </template>
                        <template v-else-if="transaction.user.noType == 3">
                          <div
                            v-if="
                              $h.isEmpty(transaction.user.foreignResidenceNo)
                            "
                          >
                            # # # # # #
                          </div>
                          <div v-else>
                            {{ transaction.user.foreignResidenceNo }}
                          </div>
                        </template>
                        <template v-else-if="transaction.user.noType == 4">
                          <div v-if="$h.isEmpty(transaction.user.others)">
                            # # # # # #
                          </div>
                          <div v-else>
                            {{ transaction.user.others }}
                          </div>
                        </template>
                      </td>
                      <td
                        class="border dark:border-dark-5 text-center"
                        style="padding: 0px !important;"
                      >
                        <div class="flex-container">
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="transaction.moneyCategoryCode == 'USD'"
                            >
                              {{
                                $h.filterCurrency(transaction.foreignCurrency)
                              }}
                            </template>
                          </div>
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="transaction.moneyCategoryCode == 'JPY'"
                            >
                              {{
                                $h.filterCurrency(transaction.foreignCurrency)
                              }}
                            </template>
                          </div>
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="transaction.moneyCategoryCode == 'TWD'"
                            >
                              {{
                                $h.filterCurrency(transaction.foreignCurrency)
                              }}
                            </template>
                          </div>
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="transaction.moneyCategoryCode == 'CNY'"
                            >
                              {{
                                $h.filterCurrency(transaction.foreignCurrency)
                              }}
                            </template>
                          </div>
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="transaction.moneyCategoryCode == 'EUR'"
                            >
                              {{
                                $h.filterCurrency(transaction.foreignCurrency)
                              }}
                            </template>
                          </div>
                          <div
                            class="dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                (transaction.moneyCategoryCode != 'EUR') &
                                  (transaction.moneyCategoryCode != 'CNY') &
                                  (transaction.moneyCategoryCode != 'TWD') &
                                  (transaction.moneyCategoryCode != 'JPY') &
                                  (transaction.moneyCategoryCode != 'USD')
                              "
                            >
                              <div class="flex">
                                <div class="w-6 border-r mx-1">
                                  <el-tooltip placement="top">
                                    <div slot="content">
                                      <span>
                                        {{ transaction.moneyCategory.country }}
                                      </span>
                                    </div>
                                    <font color="#5b8631">
                                      {{
                                        transaction.moneyCategory.country.substr(
                                          0,
                                          1
                                        )
                                      }}
                                    </font>
                                  </el-tooltip>
                                </div>
                                <div>
                                  {{
                                    $h.filterCurrency(
                                      transaction.foreignCurrency
                                    )
                                  }}
                                </div>
                              </div>
                            </template>
                          </div>
                        </div>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        {{ transaction.inRate }}
                      </td>
                      <td
                        class="relative border dark:border-dark-5 text-center"
                      >
                        <div
                          v-if="
                            transaction.cutAmount != 0 ||
                              Math.round(
                                transaction.foreignCurrency * transaction.inRate
                              ) != transaction.localCurrency
                          "
                          class="border-b-2 dark:border-dark-5 text-theme-6 mx-2"
                        >
                          {{
                            $h.filterCurrency(transaction.localOrignCurrency)
                          }}
                          <span
                            v-if="
                              transaction.createdAt != transaction.updatedAt
                            "
                            class="absolute text-xs bottom-0 right-0 text-black mr-1 mb-1 dark:text-gray-300"
                            @mouseenter="
                              (showTooltip = true),
                                (showUpdateDate = transaction.updatedAt)
                            "
                            @mouseleave="showTooltip = false"
                          >
                            수정됨
                            <div
                              v-if="
                                showTooltip &&
                                  showUpdateDate === transaction.updatedAt
                              "
                              style="position: absolute; top: 100%; left: 0; background-color: #f9f9f9; border: 1px solid #ccc; padding: 5px; z-index: 10; color: black; white-space: nowrap;"
                            >
                              {{
                                formartLocalAsUTCAndThenLocal(
                                  transaction.updatedAt
                                )
                              }}
                            </div>
                          </span>
                        </div>
                        <div class="mx-2">
                          {{ $h.filterCurrency(transaction.localRealCurrency) }}
                          <span
                            v-if="
                              transaction.createdAt != transaction.updatedAt
                            "
                            class="absolute text-xs bottom-0 right-0 text-black mr-1 mb-1 dark:text-gray-300"
                            @mouseenter="
                              (showTooltip = true),
                                (showUpdateDate = transaction.updatedAt)
                            "
                            @mouseleave="showTooltip = false"
                          >
                            수정됨
                            <div
                              v-if="
                                showTooltip &&
                                  showUpdateDate === transaction.updatedAt
                              "
                              style="position: absolute; top: 100%; left: 0; background-color: #f9f9f9; border: 1px solid #ccc; padding: 5px; z-index: 10; color: black; white-space: nowrap;"
                            >
                              {{
                                formartLocalAsUTCAndThenLocal(
                                  transaction.updatedAt
                                )
                              }}
                            </div>
                          </span>
                        </div>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <input
                          v-model="transaction.isExclusion"
                          type="checkbox"
                          autocomplete="off"
                          class="input border mr-2"
                          @change="setExclusion(transaction)"
                        />
                      </td>
                      <td
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border dark:border-dark-5 whitespace-no-wrap text-center justify-center items-center"
                      >
                        <button
                          class="button button--sm w-14 mr-1 bg-theme-12 text-white"
                          @click="clickEditBtn(transaction)"
                        >
                          수정
                        </button>
                        <button
                          class="button button--sm w-14 bg-theme-6 text-white"
                          @click="clickDeleteBtn(transaction)"
                        >
                          삭제
                        </button>
                      </td>
                      <td class="border dark:border-dark-5 text-center">
                        <div v-if="'adminName' in transaction">
                          {{ transaction.adminName }}
                        </div>
                        <div v-else>
                          ######
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td class="border dark:border-dark-5 text-center">
                        합계
                      </td>
                      <td
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border dark:border-dark-5 text-center"
                      ></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td
                        class="border dark:border-dark-5 text-center"
                        style="padding: 0px !important;"
                      >
                        <div class="flex-container">
                          <div
                            class="border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.usdAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.usdAmount) }}
                            </template>
                          </div>
                          <div
                            class="col-6 border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.jpyAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.jpyAmount) }}
                            </template>
                          </div>
                          <div
                            class="col-6 border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.twdAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.twdAmount) }}
                            </template>
                          </div>
                          <div
                            class="col-6 border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.cnyAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.cnyAmount) }}
                            </template>
                          </div>
                          <div
                            class="col-6 border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.eurAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.eurAmount) }}
                            </template>
                          </div>
                          <div
                            class="col-6 border-r dark:border-dark-5 whitespace-no-wrap text-center py-3"
                          >
                            <template
                              v-if="
                                $h.filterCurrency(totalAmount.extraAmount) != 0
                              "
                            >
                              {{ $h.filterCurrency(totalAmount.extraAmount) }}
                            </template>
                          </div>
                        </div>
                      </td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td class="border dark:border-dark-5 text-center">
                        <template
                          v-if="$h.filterCurrency(totalAmount.krwAmount) != 0"
                        >
                          {{ $h.filterCurrency(totalAmount.krwAmount) }}
                        </template>
                      </td>
                      <td class="border dark:border-dark-5 text-center"></td>
                      <td
                        v-if="$store.state.auth.user.isAdmin >= 1"
                        class="border dark:border-dark-5 text-center"
                      ></td>
                      <td class="border dark:border-dark-5 text-center"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <!-- BEGIN: Pagination -->
            <div
              class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center mt-6 hidden"
            >
              <el-pagination
                background
                layout="sizes, prev, pager, next, jumper"
                :total="total"
                :page-sizes="[50, 100, 150]"
                :page-size="listQuery.limit"
                :current-page="listQuery.page"
                @current-change="onPageChange"
                @size-change="handleSizeChange"
              ></el-pagination>
            </div>
            <!-- END: Pagination -->
          </div>
        </div>
        <!-- END: Bordered Table -->
      </div>
    </div>
    <!-- BEGIN: Delete Confirmation Modal -->
    <div id="delete-confirmation-modal" class="modal">
      <div class="modal__content">
        <div class="p-5 text-center">
          <xCircleIcon class="w-16 h-16 text-theme-6 mx-auto mt-3" />
          <div class="text-3xl mt-5 mb-5">삭제 하시겠습니까?</div>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            class="button w-24 border text-gray-700 mr-1"
            @click="hideModal"
          >
            취소
          </button>
          <button
            type="button"
            class="button w-24 bg-theme-6 text-white"
            @click="handleDelete"
          >
            삭제
          </button>
        </div>
      </div>
    </div>
    <!-- END: Delete Confirmation Modal -->
    <!-- BEGIN: Update History Confirmation Modal -->
    <div id="update-transaction-history-modal" class="modal">
      <div class="modal__content" style="width: 60vw;">
        <div class="p-5 text-center">
          <div class="text-3xl mt-5 mb-5 p-2">
            매입수정내역
          </div>
          <el-date-picker
            v-if="$store.state.auth.user.isAdmin >= 1"
            v-model="update_trans_pages_days"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="~"
            start-placeholder="시작날짜"
            end-placeholder="마지막날짜"
            value-format="yyyy-MM-dd"
            :picker-options="deletedPeriodPickerOptions"
            class="flex inline-block mt-3 lg:mt-0 p-2"
            @change="onChangeTransHistoryLogDay"
          >
          </el-date-picker>
        </div>
        <div id="bordered-table" class="p-5">
          <div class="preview">
            <div class="overflow-x-auto">
              <table class="table">
                <thead>
                  <th
                    class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                  >
                    업데이트 일시
                  </th>
                  <th
                    class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                  >
                    수정 항목
                  </th>
                  <th
                    class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                  >
                    기존 값
                  </th>
                  <th
                    class="border border-b-2 dark:border-dark-5 whitespace-no-wrap text-center"
                  >
                    변경 후 값
                  </th>
                </thead>
                <tbody>
                  <template v-for="groupedItem in update_trans_logs">
                    <tr
                      v-for="(item, itemIndex) in groupedItem.data"
                      :key="item.id"
                    >
                      <template v-if="itemIndex === 0">
                        <td
                          :rowspan="groupedItem.data.length"
                          class="border dark:border-dark-5 text-center"
                        >
                          {{
                            formartLocalAsUTCAndThenLocal(
                              groupedItem.updateDate
                            )
                          }}
                        </td>
                      </template>
                      <td
                        v-if="
                          item.modificationDetails === '원화금액' &&
                            shouldReduceFont(groupedItem)
                        "
                        class="border dark:border-dark-5 text-center"
                        style="font-size: 0.7rem;"
                      >
                        {{ item.modificationDetails }}
                      </td>

                      <td v-else class="border dark:border-dark-5 text-center">
                        {{ item.modificationDetails }}
                      </td>

                      <td
                        v-if="
                          item.modificationDetails === '원화금액' &&
                            shouldReduceFont(groupedItem)
                        "
                        class="border dark:border-dark-5 text-center"
                        style="font-size: 0.7rem;"
                      >
                        <p v-if="isIntegerString(item.originalValue)">
                          {{ formatIntIfString(item.originalValue) }}
                        </p>
                        <p v-else>
                          {{ item.originalValue }}
                        </p>
                      </td>

                      <td v-else class="border dark:border-dark-5 text-center">
                        <p v-if="isIntegerString(item.originalValue)">
                          {{ formatIntIfString(item.originalValue) }}
                        </p>
                        <p v-else>
                          {{ item.originalValue }}
                        </p>
                      </td>

                      <td
                        v-if="
                          item.modificationDetails === '원화금액' &&
                            shouldReduceFont(groupedItem)
                        "
                        class="border dark:border-dark-5 text-center"
                        style="font-size: 0.7rem;"
                      >
                        <p v-if="isIntegerString(item.updatedValue)">
                          {{ formatIntIfString(item.updatedValue) }}
                        </p>
                        <p v-else>
                          {{ item.updatedValue }}
                        </p>
                      </td>

                      <td v-else class="border dark:border-dark-5 text-center">
                        <p v-if="isIntegerString(item.updatedValue)">
                          {{ formatIntIfString(item.updatedValue) }}
                        </p>
                        <p v-else>
                          {{ item.updatedValue }}
                        </p>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="px-5 pb-8 text-center">
          <el-pagination
            background
            layout="sizes, prev, pager, next, jumper"
            :total="update_trans_page_info.total"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="update_trans_page_info.pageSize"
            :current-page="update_trans_page_info.currentPage"
            @current-change="onUpdateTransLogsPageChange"
            @size-change="onUpdateTransLogsSizeChange"
          ></el-pagination>
        </div>
        <div class="px-5 pb-8 text-center">
          <button
            type="button"
            class="button w-20 bg-theme-1 text-white dark:border-dark-1 dark:text-gray-300 mr-1"
            @click="hideModal"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
    <!-- END: Update History Modal -->
    <div id="edit-modal-preview" class="modal">
      <div class="modal__content">
        <div
          class="flex items-center px-5 py-5 sm:py-3 border-b border-gray-200 dark:border-dark-5 relative"
        >
          <h2 class="font-medium text-base mr-auto">매입수정</h2>
          <a
            href="javascript:;"
            class="absolute right-0 top-0 mt-3 mr-3"
            @click="hideModal"
          >
            <xIcon class="w-8 h-8 text-gray-500" />
          </a>
        </div>
        <div class="px-10 py-5 grid grid-cols-12 row-gap-2">
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                성명
              </label>
              <input
                v-model="register.userName"
                type="email"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                국적
              </label>
              <div class="intro-x relative w-full flex-1">
                <input
                  id="inputNationality"
                  v-model="register.nationalityName"
                  type="text"
                  autocomplete="off"
                  class="input w-full border mt-2 flex-1"
                  placeholder="국적"
                  @focus="showSearchDropdown"
                  @blur="hideSearchDropdown"
                  @input="onChangeInputCountry($event)"
                  @keyup.enter="enterSelectCountry()"
                />
                <div
                  class="dropdown-box w-full"
                  :class="{ show: searchDropdown }"
                >
                  <div
                    class="dropdown-box__content box dark:bg-dark-1 p-2 overflow-y-auto h-32"
                  >
                    <a
                      v-for="(country, index) in countries"
                      :key="index"
                      class="flex items-center block p-2 transition duration-300 ease-in-out bg-white dark:bg-dark-1 hover:bg-gray-200 dark:hover:bg-dark-2 rounded-md"
                      @click="onSelectCountry(country)"
                      >{{ country.name }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                여권번호
              </label>
              <input
                v-model="register.passportNo"
                type="email"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                주민등록번호
              </label>
              <input
                v-model="register.residenceNo"
                type="email"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:text-left" style="width: 7rem; sm:mr-5">
                외국인등록번호
              </label>
              <input
                v-model="register.foreignResidenceNo"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                기타
              </label>
              <input
                v-model="register.others"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                화폐단위
              </label>
              <select
                v-model="register.moneyCategoryCode"
                type="text"
                class="input w-full sm:w-auto border mt-2 flex-1"
                @change="moneyCategoryChange()"
              >
                <option
                  v-for="(moneyCategory, index) in $store.state.main
                    .moneyCategories"
                  :key="index"
                  :value="moneyCategory.code"
                >
                  <h2 class="font-medium text-base mr-auto">
                    {{ moneyCategory.name }}
                    ({{ moneyCategory.unit }})
                  </h2>
                </option>
              </select>
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                외화금액
              </label>
              <currency-input
                id="inputForeignCurrency"
                v-model="register.foreignCurrency"
                :currency="{
                  prefix: register.moneyCategoryUnit
                }"
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
                @input="onChangeInputForeignCurrency()"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                환율
              </label>
              <input
                v-if="register.exchangeType == 1"
                v-model="register.inRate"
                type="email"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
                @input="onChangeInputForeignCurrency()"
              />
              <input
                v-else
                v-model="register.outRate"
                type="email"
                placeholder=""
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center">
              <label class="w-full sm:w-24 sm:text-left sm:mr-5">
                원화금액
              </label>
              <currency-input
                v-model="register.localCurrency"
                currency="KRW"
                autocomplete="off"
                class="input w-full sm:w-auto border mt-2 flex-1"
              />
            </div>
          </div>
          <div class="col-span-12">
            <div class="flex flex-col sm:flex-row items-center mt-2">
              <label
                v-if="register.exchangeType == 1"
                class="w-full sm:w-24 sm:text-left sm:mr-5"
              >
                절상
              </label>
              <label
                v-if="register.exchangeType == 2"
                class="w-full sm:w-24 sm:text-left sm:mr-5"
              >
                절하
              </label>
              <div class="w-full sm:w-auto flex-1">
                <el-checkbox v-model="optionValue1" @input="onClickOption(1)">
                  10
                </el-checkbox>
                <el-checkbox
                  v-model="optionValue2"
                  class="ml-2"
                  @input="onClickOption(2)"
                >
                  50
                </el-checkbox>
                <el-checkbox
                  v-model="optionValue3"
                  class="ml-4"
                  @input="onClickOption(3)"
                >
                  100
                </el-checkbox>
                <el-checkbox v-model="optionValue4" @input="onClickOption(4)">
                  500
                </el-checkbox>
                <el-checkbox v-model="optionValue5" @input="onClickOption(5)">
                  1000
                </el-checkbox>
                <el-checkbox v-model="optionValue6" @input="onClickOption(6)">
                  5000
                </el-checkbox>
                <el-checkbox v-model="optionValue7" @input="onClickOption(7)">
                  10000
                </el-checkbox>
              </div>
            </div>
          </div>
        </div>
        <div
          class="px-5 py-3 text-right border-t border-gray-200 dark:border-dark-5"
        >
          <button
            type="button"
            class="button w-20 text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            @click="clickUpdateTransactoryLogBtn(register.id)"
          >
            수정이력
          </button>
          <button
            type="button"
            class="button w-20 text-gray-700 dark:border-dark-5 dark:text-gray-300 mr-1"
            @click="hideModal"
          >
            취소
          </button>
          <button
            type="button"
            class="button w-20 bg-theme-1 text-white"
            @click="handleUpdate"
          >
            수정
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Toastify from "toastify-js";
import jQuery from "jquery";
import { export_json_to_excel } from "@/assets/js/vendor/Export2Excel";

let modalType = 0;

export default {
  data() {
    return {
      optionValue1: false,
      optionValue2: false,
      optionValue3: false,
      optionValue4: false,
      optionValue5: false,
      optionValue6: false,
      optionValue7: false,
      agencies: [],
      countries: [],
      tmpCountries: [],
      searchDropdown: false,
      transactions: [],
      total: 0,
      totalAmount: {},
      listQuery: {
        page: 1,
        limit: 10000,
        dateRange: ["", ""]
      },
      startDay: "",
      endDay: "",
      agencyId: "",
      moneyCategoryCode: "",
      moneyCategoryUnit: "",
      register: {
        userId: -1,
        id: -1,
        userName: "",
        nationality: "",
        nationalityName: "",
        passportNo: "",
        residenceNo: "",
        foreignResidenceNo: "",
        others: "",
        exchangeType: 1,
        inRate: 1,
        outRate: 1,
        foreignCurrency: 0,
        localCurrency: 0,
        localOrignCurrency: 0,
        cutAmount: 0,
        prevCutAmount: 0,
        token: "",
        moneyCategoryCode: "USD"
      },
      tempTransaction: {
        userId: -1,
        id: -1,
        userName: "",
        nationality: "",
        nationalityName: "",
        passportNo: "",
        residenceNo: "",
        foreignResidenceNo: "",
        others: "",
        exchangeType: 1,
        outRate: 1,
        inRate: 1,
        foreignCurrency: 0,
        localCurrency: 0,
        localOrignCurrency: 0,
        cutAmount: 0,
        prevCutAmount: 0,
        token: "",
        moneyCategoryCode: "USD"
      },
      showTooltip: false,
      showUpdateDate: "",
      update_trans_logs: [],
      update_trans_page_info: {
        total: 0,
        pageSize: 10,
        currentPage: 1
      },
      update_trans_pages_days: ["", ""],
      LogStartDay: "",
      LogEndDay: "",
      admins: [],
      adminName: "",
      selectedId: -1,
      localAdmins: []
    };
  },
  async mounted() {
    let date = new Date();
    this.startDay = moment(date).format("YYYY-MM-DD");
    this.listQuery.dateRange = [this.startDay, this.startDay];
    await this.getAgencies();
    await this.getCountries();
    await this.getAdmins();
    await this.getTransactions();
  },
  async created() {
    // if (this.$store.state.auth.user.isAdmin >= 1) {
    //   this.$store.dispatch("main/setPassportInfo", 0);
    // } else {
    this.$store.dispatch("main/setPassportInfo", 1);
    this.$store.dispatch("main/setIsShowBtn", true);
    // }
    await this.tokenLogin();
    window.addEventListener("keyup", this.functionEnter);
  },
  methods: {
    async tokenLogin() {
      let data = {
        token: window.localStorage.getItem("exchange_token")
      };
      let resultData = {};
      await axios.post(this.$api().tokenLogin, data).then(res => {
        resultData = res.data;
      });
      if (this.$h.isEmpty(resultData)) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else if (resultData.error) {
        this.$store.commit("auth/SET_USER", null);
        this.$store.commit("auth/SET_ISLOGINED", false);
        this.$router.replace("/");
      } else {
        this.$store.commit("auth/SET_USER", resultData.userData);
        this.$store.commit("auth/SET_ISLOGINED", true);
        window.localStorage.setItem(
          "exchange_token",
          resultData.userData.token
        );
      }
    },
    async functionEnter(ev) {
      if (ev.key === "Enter") {
        if (this.register.id != -1) {
          if (modalType == 1) {
            await this.handleUpdate();
          } else if (modalType == 2) {
            await this.handleDelete();
          }
        }
      }
      window.removeEventListener("beforeunload", this.functionEnter);
    },
    initRegister() {
      this.register.userId = -1;
      this.register.id = -1;
      this.register.userName = "";
      this.register.nationality = "";
      this.register.nationalityName = "";
      this.register.passportNo = "";
      this.register.residenceNo = "";
      this.register.foreignResidenceNo = "";
      this.register.others = "";
      this.register.exchangeType = 1;
      this.register.inRate = 1;
      this.register.outRate = 1;
      this.register.foreignCurrency = 0;
      this.register.localCurrency = 0;
      this.register.localOrignCurrency = 0;
      this.register.cutAmount = 0;
      this.register.prevCutAmount = 0;
      this.register.token = "";
      this.register.moneyCategoryCode = "";
      this.register.moneyCategoryUnit = "";
      this.register.createdAt = "";

      this.tempTransaction.userId = -1;
      this.tempTransaction.id = -1;
      this.tempTransaction.userName = "";
      this.tempTransaction.nationality = "";
      this.tempTransaction.nationalityName = "";
      this.tempTransaction.passportNo = "";
      this.tempTransaction.residenceNo = "";
      this.tempTransaction.foreignResidenceNo = "";
      this.tempTransaction.others = "";
      this.tempTransaction.exchangeType = 1;
      this.tempTransaction.inRate = 1;
      this.tempTransaction.outRate = 1;
      this.tempTransaction.foreignCurrency = 0;
      this.tempTransaction.localCurrency = 0;
      this.tempTransaction.localOrignCurrency = 0;
      this.tempTransaction.cutAmount = 0;
      this.tempTransaction.prevCutAmount = 0;
      this.tempTransaction.token = "";
      this.tempTransaction.moneyCategoryCode = "";
      this.tempTransaction.moneyCategoryUnit = "";
      this.tempTransaction.createdAt = "";
    },
    initOptions(type) {
      this.register.cutAmount = 0;
      type == 1 ? (this.optionValue1 = true) : (this.optionValue1 = false);
      type == 2 ? (this.optionValue2 = true) : (this.optionValue2 = false);
      type == 3 ? (this.optionValue3 = true) : (this.optionValue3 = false);
      type == 4 ? (this.optionValue4 = true) : (this.optionValue4 = false);
      type == 5 ? (this.optionValue5 = true) : (this.optionValue5 = false);
      type == 6 ? (this.optionValue6 = true) : (this.optionValue6 = false);
      type == 7 ? (this.optionValue7 = true) : (this.optionValue7 = false);
    },
    async onUpdateTransLogsPageChange(newPage) {
      this.update_trans_page_info.currentPage = newPage;
      await this.GetUpdateTransLogs(this.register.id);
    },
    async onUpdateTransLogsSizeChange(newSize) {
      this.update_trans_page_info.currentPage = 1;
      this.update_trans_page_info.pageSize = newSize;
      await this.GetUpdateTransLogs(this.register.id);
    },
    async onChangeAdmin(event) {
      if (this.adminName != "전체") {
        this.selectedId = event.target.value;
        if (isNaN(parseInt(this.selectedId))) {
          this.selectedId = -1;
        }
      } else {
        this.selectedId = -1;
      }
      this.getTransactions();
    },
    calcOneWeek() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 7);
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getTransactions();
    },
    calcOneMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(date.getTime() - 3600 * 1000 * 24 * 30);
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getTransactions();
    },
    calcThreeMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(
        date.getTime() - 3600 * 1000 * 24 * 30 * 3 - 3600 * 1000 * 24 * 2
      );
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getTransactions();
    },
    calcSixMonth() {
      let date = new Date();
      this.endDay = moment(date).format("YYYY-MM-DD");
      let startDate = new Date(
        date.getTime() - 3600 * 1000 * 24 * 30 * 6 - 3600 * 1000 * 24 * 4
      );
      this.startDay = moment(startDate).format("YYYY-MM-DD");
      this.listQuery.dateRange = [this.startDay, this.endDay];
      this.getTransactions();
    },
    onChangeDay() {
      this.getTransactions();
    },
    onChangeTransHistoryLogDay() {
      this.GetUpdateTransLogs(this.register.id);
    },
    formartLocalAsUTCAndThenLocal(localTimeString) {
      //// console.log("localTimeString : ", localTimeString);
      // 1. 로컬 시간을 밀리초로 변환
      const localTimeMilliseconds = new Date(localTimeString).getTime();

      // 2. 현재 시스템의 시간대 오프셋 (분 단위)
      const timezoneOffsetMinutes = new Date().getTimezoneOffset();

      // 3. 시간대 오프셋을 밀리초로 변환
      const timezoneOffsetMilliseconds = timezoneOffsetMinutes * 60 * 1000;

      // 4. 로컬 시간 밀리초에서 오프셋을 빼서 UTC 밀리초를 얻음
      const utcTimeMilliseconds =
        localTimeMilliseconds + timezoneOffsetMilliseconds;

      // 5. UTC 밀리초를 Date 객체로 생성
      const utcDate = new Date(utcTimeMilliseconds);

      // 6. UTC Date 객체를 현지 시간 형식으로 포맷팅
      const year = utcDate.getFullYear();
      const month = String(utcDate.getMonth() + 1).padStart(2, "0");
      const day = String(utcDate.getDate()).padStart(2, "0");
      const hour = String(utcDate.getHours()).padStart(2, "0");
      const minute = String(utcDate.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day} ${hour}:${minute}`;
    },
    async getAgencies() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getAgencies, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.agencies = resultData.data;
      });
    },
    async getAdmins() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        agencyId: this.$store.state.auth.user.agencyId,
        isAdmin: this.$store.state.auth.user.isAdmin
      };
      await axios.post(this.$api().getAdmins, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.admins = resultData.data.filter(item => item.isAdmin === 0);
        this.localAdmins = resultData.data.filter(item => item.isAdmin === 0);
      });
    },
    async getTransactions() {
      this.localAdmins = [];
      if (!isNaN(parseInt(this.agencyId))) {
        this.localAdmins = this.admins.filter(
          item => item.agencyId == this.agencyId
        );
        var items = this.localAdmins.filter(item => item.id == this.selectedId);
        if (items.length == 0) {
          this.selectedId = -1;
          this.adminName = "";
        }
      } else {
        this.localAdmins = this.admins;
      }
      //console.log("auth : ", this.$store.state.auth.user);
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        exchangeType: 1,
        passportInfo: this.$store.state.main.passportInfo,
        agencyId: this.agencyId,
        moneyCategoryCode: this.moneyCategoryCode,
        startDay: this.listQuery.dateRange[0],
        endDay: this.listQuery.dateRange[1],
        limit: this.listQuery.limit,
        offset: (this.listQuery.page - 1) * this.listQuery.limit,
        adminId: this.selectedId
      };
      this.showLoading();
      await axios.post(this.$api().getTransactions, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.transactions = resultData.data;
        //console.log("Get Transaction data from server : ", resultData.data);
        this.total = resultData.total;
        //console.log("total : ", this.total);
        this.totalAmount = resultData.totalAmount;
      });
      this.hideLoading();
    },
    clickEditBtn(transaction) {
      if (transaction.isExclusion == 1) {
        Toastify({
          text: "제외항목은 수정 할수 없습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      modalType = 1;
      this.initOptions(0);
      this.register.userName = transaction.user.name;
      this.register.nationalityName = "";
      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].code == transaction.user.nationality) {
          this.register.nationalityName = this.countries[i].name;
          break;
        }
      }
      this.register.nationality = transaction.user.nationality;
      this.register.passportNo = transaction.user.passportNo;
      this.register.residenceNo = transaction.user.residenceNo;
      this.register.foreignResidenceNo = transaction.user.foreignResidenceNo;
      this.register.others = transaction.user.others;
      this.register.noType = transaction.user.noType;
      this.register.localCurrency = transaction.localCurrency;
      this.register.moneyCategoryCode = transaction.moneyCategoryCode;
      for (let i = 0; i < this.$store.state.main.moneyCategories.length; i++) {
        if (
          this.$store.state.main.moneyCategories[i].code ==
          transaction.moneyCategoryCode
        ) {
          this.register.moneyCategoryUnit =
            this.$store.state.main.moneyCategories[i].unit + " ";
        }
      }
      this.register.foreignCurrency = transaction.foreignCurrency;
      this.register.inRate = transaction.inRate;
      this.register.outRate = transaction.outRate;
      this.register.exchangeType = transaction.exchangeType;
      this.register.localOrignCurrency = transaction.localOrignCurrency;
      this.register.prevCutAmount = transaction.cutAmount;
      this.register.cutAmount = transaction.cutAmount;
      this.register.userId = transaction.user.id;
      this.register.id = transaction.id;
      this.register.createdAt = transaction.createdAt;
      if (this.register.cutAmount == 10) {
        this.initOptions(1);
      } else if (this.register.cutAmount == 50) {
        this.initOptions(2);
      } else if (this.register.cutAmount == 100) {
        this.initOptions(3);
      } else if (this.register.cutAmount == 500) {
        this.initOptions(4);
      } else if (this.register.cutAmount == 1000) {
        this.initOptions(5);
      } else if (this.register.cutAmount == 5000) {
        this.initOptions(6);
      } else if (this.register.cutAmount == 10000) {
        this.initOptions(7);
      }
      this.tempTransaction.userName = transaction.user.name;
      this.tempTransaction.nationalityName = "";
      for (let i = 0; i < this.countries.length; i++) {
        if (this.countries[i].code == transaction.user.nationality) {
          this.tempTransaction.nationalityName = this.countries[i].name;
          break;
        }
      }
      this.tempTransaction.nationality = transaction.user.nationality;
      this.tempTransaction.passportNo = transaction.user.passportNo;
      this.tempTransaction.residenceNo = transaction.user.residenceNo;
      this.tempTransaction.foreignResidenceNo =
        transaction.user.foreignResidenceNo;
      this.tempTransaction.others = transaction.user.others;
      this.tempTransaction.noType = transaction.user.noType;
      this.tempTransaction.localCurrency = parseInt(transaction.localCurrency);
      this.tempTransaction.moneyCategoryCode = transaction.moneyCategoryCode;
      for (let i = 0; i < this.$store.state.main.moneyCategories.length; i++) {
        if (
          this.$store.state.main.moneyCategories[i].code ==
          transaction.moneyCategoryCode
        ) {
          this.tempTransaction.moneyCategoryUnit =
            this.$store.state.main.moneyCategories[i].unit + " ";
        }
      }
      this.tempTransaction.foreignCurrency = transaction.foreignCurrency;
      this.tempTransaction.inRate = transaction.inRate;
      this.tempTransaction.outRate = transaction.outRate;
      this.tempTransaction.exchangeType = transaction.exchangeType;
      this.tempTransaction.localOrignCurrency = transaction.localOrignCurrency;
      this.tempTransaction.prevCutAmount = transaction.cutAmount;
      this.tempTransaction.cutAmount = transaction.cutAmount;
      this.tempTransaction.userId = transaction.user.id;
      this.tempTransaction.id = transaction.id;
      this.tempTransaction.createdAt = transaction.createdAt;
      cash("#edit-modal-preview").modal("toggle");
    },
    clickDeleteBtn(trans) {
      if (trans.isExclusion == 1) {
        Toastify({
          text: "제외항목은 삭제 할수 없습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "bottom",
          position: "left",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      modalType = 2;
      this.register.id = trans.id;
      this.register.createdAt = trans.createdAt;
      cash("#delete-confirmation-modal").modal("toggle");
    },
    async clickUpdateTransactoryLogBtn(transactionId) {
      modalType = 3;
      await this.GetUpdateTransLogs(transactionId);
      cash("#update-transaction-history-modal").modal("toggle");
    },
    isIntegerString(value) {
      return typeof value === "string" && /^\d+$/.test(value);
    },
    formatIntIfString(value) {
      if (this.isIntegerString(value)) {
        const num = parseInt(value, 10);
        return num.toLocaleString();
      }
      return value;
    },
    shouldReduceFont(groupedItem) {
      const isWonAmountPresent = groupedItem.data.some(
        item => item.modificationDetails === "원화금액"
      );
      const hasRelatedDetails = groupedItem.data.some(
        item =>
          item.modificationDetails === "환율" ||
          item.modificationDetails === "외화금액"
      );
      return isWonAmountPresent && hasRelatedDetails;
    },
    async GetUpdateTransLogs(transactionId) {
      // console.log("getUpdateTransactionLogs transactionId : ", transactionId);
      this.LogStartDay = "";
      this.LogEndDay = "";
      if (
        this.update_trans_pages_days[0] == null ||
        this.update_trans_pages_days[0] == ""
      ) {
        this.LogStartDay = "";
      } else {
        this.LogStartDay = this.update_trans_pages_days[0];
      }
      if (
        this.update_trans_pages_days[1] == null ||
        this.update_trans_pages_days[1] == ""
      ) {
        this.LogEndDay = "";
      } else {
        this.LogEndDay = this.update_trans_pages_days[1];
      }
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        transactionId: transactionId,
        pageSize: this.update_trans_page_info.pageSize,
        currentPage: this.update_trans_page_info.currentPage,
        totalSize: this.update_trans_page_info.total,
        startDay: this.LogStartDay,
        endDay: this.LogEndDay
      };
      //// console.log("data : ", data);
      await axios.post(this.$api().getUpdateTransLogs, data).then(res => {
        this.update_trans_logs = res.data.data;
        this.update_trans_page_info.total = res.data.total;
        this.update_trans_logs.sort((a, b) => {
          const dateA = new Date(a.updateDate);
          const dateB = new Date(b.updateDate);
          return dateA.getTime() - dateB.getTime(); // 내림차순 (미래 -> 과거)
        });
        //// console.log("type of result data", typeof res.data.data);
        //// console.log("getUpdateTransLogs : ", this.update_trans_logs);
      });
    },
    async setExclusion(transaction) {
      let selectedItemDay = this.$h.formatDate(
        transaction.createdAt,
        "YYYY-MM-DD"
      );
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      if (selectedItemDay != currentDay) {
        Toastify({
          text: "당일에 한한 매입이력만 제외하실수 있습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        this.showLoading();
        this.getTransactions();
        this.hideLoading();
        return;
      }
      this.showLoading();
      const data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        isExclusion: transaction.isExclusion,
        id: transaction.id
      };
      await axios.post(this.$api().setExclusion, data).then(res => {
        this.hideLoading();
        if (res.status == 200) {
          this.getTransactions();
        } else {
          if (res.data.data == false) {
            transaction.isExclusion = 0;
            Toastify({
              text: "매입금액이 매출금액보다 적습니다",
              duration: 3000,
              newWindow: true,
              close: true,
              gravity: "top",
              position: "right",
              backgroundColor: "#e53231",
              stopOnFocus: true
            }).showToast();
          } else {
            Toastify({
              text: "오류",
              duration: 3000,
              newWindow: true,
              close: true,
              gravity: "top",
              position: "right",
              backgroundColor: "#e53231",
              stopOnFocus: true
            }).showToast();
          }
        }
      });
    },
    onPageChange(val) {
      this.listQuery.page = val;
      this.getTransactions();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getTransactions();
    },
    onSelectCountry(country) {
      this.register.nationalityName = country.name;
      this.register.nationality = country.code;
    },
    enterSelectCountry() {
      const countryName = this.register.nationalityName;
      this.countries = this.$h.findItemsFromArray(
        this.tmpCountries,
        countryName
      );
      if (this.countries.length > 0) {
        this.register.nationalityName = this.countries[0].name;
        this.register.nationality = this.countries[0].code;
      } else {
        this.register.nationality = "";
      }
    },
    onChangeInputCountry() {
      const countryName = jQuery("#inputNationality").val();
      this.countries = this.$h.findItemsFromArray(
        this.tmpCountries,
        countryName
      );
      if (!this.$h.isEmpty(countryName) && this.countries.length > 0) {
        this.register.nationality = this.countries[0].code;
      } else {
        this.register.nationality = "";
      }
    },
    onChangeInputForeignCurrency() {
      this.initOptions(0);
      // =================================
      // :    init localCurrency
      // =================================
      if (this.register.exchangeType == 1) {
        this.register.localCurrency = Math.round(
          this.register.foreignCurrency * this.register.inRate
        );
      } else {
        this.register.localCurrency = Math.round(
          this.register.foreignCurrency * this.register.outRate
        );
      }
      // =================================
      // :    init localOrignCurrency
      // =================================
      this.register.localOrignCurrency = this.register.localCurrency;
    },
    moneyCategoryChange() {
      for (let i = 0; i < this.$store.state.main.moneyCategories.length; i++) {
        if (
          this.$store.state.main.moneyCategories[i].code ==
          this.register.moneyCategoryCode
        ) {
          this.register.moneyCategoryUnit =
            this.$store.state.main.moneyCategories[i].unit + " ";
        }
      }
    },
    showSearchDropdown() {
      this.searchDropdown = true;
    },
    hideSearchDropdown() {
      this.searchDropdown = false;
    },
    async getCountries() {
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      await axios.post(this.$api().getCountries, data).then(res => {
        let resultData = this.$h.assign(res.data);
        this.countries = resultData.data;
        this.tmpCountries = [...this.countries];
      });
    },
    async handleUpdateTransLog() {
      let differences = [];
      for (let key in this.register) {
        if (String(this.register[key]) !== String(this.tempTransaction[key])) {
          let fieldName = "";
          switch (String(key)) {
            case "userName":
              fieldName = "성명";
              break;
            case "nationality":
              fieldName = "국적";
              break;
            case "passportNo":
              fieldName = "여권번호";
              break;
            case "residenceNo":
              fieldName = "주민등록번호";
              break;
            case "foreignResidenceNo":
              fieldName = "외국인등록번호";
              break;
            case "others":
              fieldName = "기타";
              break;
            case "inRate":
              fieldName = "환율";
              break;
            case "foreignCurrency":
              fieldName = "외화금액";
              break;
            case "localCurrency":
              fieldName = "원화금액";
              break;
            case "moneyCategoryCode":
              fieldName = "화폐 변경";
              break;
            default:
              break;
          }
          if (fieldName == "") {
            continue;
          }
          // console.log("fieldName : ", fieldName);
          let updatedValue = "";
          let originalValue = "";
          if (String(key) == "moneyCategoryCode") {
            updatedValue =
              String(this.register[key]) +
              " " +
              this.register.moneyCategoryUnit;
            originalValue =
              String(this.tempTransaction[key]) +
              " " +
              this.tempTransaction.moneyCategoryUnit;
          } else {
            updatedValue = String(this.register[key]);
            originalValue = String(this.tempTransaction[key]);
          }
          differences.push({
            transactionId: this.register.id,
            modificationDetails: fieldName,
            updatedValue: updatedValue,
            originalValue: originalValue,
            updateDate: new Date()
          });
        }
      }
      //// console.log(differences);
      let data = {
        token: this.$h.assign(this.$store.state.auth.user.token),
        logs: differences
      };
      await axios.post(this.$api().addUpdateTransLog, data);
    },
    async handleUpdate() {
      setTimeout(async () => {
        let selectedItemDay = this.$h.formatDate(
          this.register.createdAt,
          "YYYY-MM-DD"
        );
        let date = new Date();
        let currentDay = moment(date).format("YYYY-MM-DD");
        if (selectedItemDay != currentDay) {
          Toastify({
            text: "당일에 한한 매입이력만 수정 하실수 있습니다.",
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
          return;
        }
        await this.handleUpdateTransLog();
        this.register.token = this.$h.assign(this.$store.state.auth.user.token);
        this.showLoading();
        //// console.log("tempTransaction : ", this.tempTransaction);
        //// console.log("this.register : ", this.register);
        await axios
          .post(this.$api().editTransaction, this.register)
          .then(res => {
            this.initRegister();
            if (res.status == 200) {
              this.getTransactions();
            } else {
              Toastify({
                text: "오류",
                duration: 3000,
                newWindow: true,
                close: true,
                gravity: "top",
                position: "right",
                backgroundColor: "#0e2c88",
                stopOnFocus: true
              }).showToast();
            }
          });
        this.hideLoading();
        this.hideModal();
      }, 100);
    },
    async handleDelete() {
      let data = {
        id: this.register.id,
        token: this.$h.assign(this.$store.state.auth.user.token)
      };
      let selectedItemDay = this.$h.formatDate(
        this.register.createdAt,
        "YYYY-MM-DD"
      );
      let date = new Date();
      let currentDay = moment(date).format("YYYY-MM-DD");
      if (selectedItemDay != currentDay) {
        Toastify({
          text: "당일에 한한 매입이력만 삭제하실수 있습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }
      this.showLoading();
      await axios.post(this.$api().deleteTransaction, data).then(res => {
        this.initRegister();
        if (res.status == 200) {
          this.getTransactions();
        } else if (res.data.data == false) {
          Toastify({
            text: "매입금액이 매출금액보다 적습니다",
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            backgroundColor: "#e53231",
            stopOnFocus: true
          }).showToast();
        } else {
          Toastify({
            text: "오류",
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "top",
            position: "right",
            backgroundColor: "#0e2c88",
            stopOnFocus: true
          }).showToast();
        }
      });
      this.hideLoading();
      this.hideModal();
    },
    hideModal() {
      if (modalType == 1) {
        cash("#edit-modal-preview").modal("hide");
      } else if (modalType == 2) {
        cash("#delete-confirmation-modal").modal("hide");
      } else if (modalType == 3) {
        cash("#update-transaction-history-modal").modal("hide");
      } else {
        cash("#edit-modal-preview").modal("hide");
        cash("#delete-confirmation-modal").modal("hide");
        cash("#update-transaction-history-modal").modal("hide");
      }
      modalType = 0;
    },
    showLoading() {
      this.$store.dispatch("main/setLoading", true);
    },
    hideLoading() {
      this.$store.dispatch("main/setLoading", false);
    },
    onClickOption(type) {
      if (type == 1) {
        if (this.optionValue1 == true) {
          this.initOptions(1);
          this.register.cutAmount = 10;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 2) {
        if (this.optionValue2 == true) {
          this.initOptions(2);
          this.register.cutAmount = 50;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 3) {
        if (this.optionValue3 == true) {
          this.initOptions(3);
          this.register.cutAmount = 100;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 4) {
        if (this.optionValue4 == true) {
          this.initOptions(4);
          this.register.cutAmount = 500;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 5) {
        if (this.optionValue5 == true) {
          this.initOptions(5);
          this.register.cutAmount = 1000;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 6) {
        if (this.optionValue6 == true) {
          this.initOptions(6);
          this.register.cutAmount = 5000;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      } else if (type == 7) {
        if (this.optionValue7 == true) {
          this.initOptions(7);
          this.register.cutAmount = 10000;
          this.initLocalCurrency();
        } else {
          this.initOptions(0);
          this.register.cutAmount = 0;
          this.initOrignLocalCurrency();
        }
      }
    },
    initLocalCurrency() {
      // =================================
      // :    init localCutCurrency
      // =================================
      this.register.localCutCurrency = this.$h.cutNumber(
        this.register.localCurrency,
        this.register.cutAmount,
        this.register.exchangeType
      );
      // =================================
      // :    init localCurrency
      // =================================
      this.register.localCurrency = this.register.localCutCurrency;
    },
    initOrignLocalCurrency() {
      // =================================
      // :    init localCurrency
      // =================================
      if (this.register.exchangeType == 1) {
        this.register.localCurrency = Math.round(
          this.register.foreignCurrency * this.register.inRate
        );
      } else {
        this.register.localCurrency = Math.round(
          this.register.foreignCurrency * this.register.outRate
        );
      }
    },
    exportExcel() {
      let th;
      if (this.$store.state.auth.user.isAdmin >= 1) {
        th = [
          "순번",
          "지점이름",
          "날짜",
          "시간",
          "이름",
          "실명번호",
          "국적",
          "구분",
          "미국",
          "일본",
          "대만",
          "중국",
          "유럽",
          "기타",
          "환율",
          "총액",
          "제외"
        ];
      } else {
        th = [
          "순번",
          "날짜",
          "시간",
          "이름",
          "실명번호",
          "국적",
          "구분",
          "미국",
          "일본",
          "대만",
          "중국",
          "유럽",
          "기타",
          "환율",
          "총액",
          "제외"
        ];
      }
      let jsonData = [];
      for (let i = 0; i < this.transactions.length; i++) {
        if (this.transactions[i].isExclusion === 1) {
          continue;
        }
        let row = [];
        row.push(i + 1);
        if (this.$store.state.auth.user.isAdmin >= 1) {
          row.push(
            this.$h.findItemFromArray(
              this.agencies,
              this.transactions[i].agencyId
            )[0].name
          );
        }
        row.push(this.$h.formatDate(this.transactions[i].updatedAt, "MM/DD"));
        row.push(this.$h.formatDate(this.transactions[i].updatedAt, "HH:mm"));
        row.push(this.transactions[i].user.name);
        if (this.transactions[i].user.noType == 1) {
          row.push(this.transactions[i].user.residenceNo);
        } else if (this.transactions[i].user.noType == 2) {
          row.push(this.transactions[i].user.passportNo);
        } else if (this.transactions[i].user.noType == 2) {
          row.push(this.transactions[i].user.passportNo);
        } else if (this.transactions[i].user.noType == 3) {
          row.push(this.transactions[i].user.foreignResidenceNo);
        } else if (this.transactions[i].user.noType == 4) {
          row.push(this.transactions[i].user.others);
        } else {
          row.push("");
        }
        row.push(this.transactions[i].user.nationality);
        if (this.$h.isEmpty(this.transactions[i].user.noType)) {
          row.push("");
        } else {
          row.push("0" + this.transactions[i].user.noType);
        }
        if (this.transactions[i].moneyCategoryCode === "USD") {
          row.push(this.transactions[i].foreignCurrency);
          row.push("");
          row.push("");
          row.push("");
          row.push("");
          row.push("");
        } else if (this.transactions[i].moneyCategoryCode === "JPY") {
          row.push("");
          row.push(this.transactions[i].foreignCurrency);
          row.push("");
          row.push("");
          row.push("");
          row.push("");
        } else if (this.transactions[i].moneyCategoryCode === "TWD") {
          row.push("");
          row.push("");
          row.push(this.transactions[i].foreignCurrency);
          row.push("");
          row.push("");
          row.push("");
        } else if (this.transactions[i].moneyCategoryCode === "CNY") {
          row.push("");
          row.push("");
          row.push("");
          row.push(this.transactions[i].foreignCurrency);
          row.push("");
          row.push("");
        } else if (this.transactions[i].moneyCategoryCode === "EUR") {
          row.push("");
          row.push("");
          row.push("");
          row.push("");
          row.push(this.transactions[i].foreignCurrency);
          row.push("");
        } else {
          row.push("");
          row.push("");
          row.push("");
          row.push("");
          row.push("");
          row.push(
            this.transactions[i].foreignCurrency +
              "(" +
              this.transactions[i].moneyCategory.country +
              ")"
          );
        }
        row.push(this.transactions[i].inRate);
        row.push(
          this.transactions[i].foreignCurrency * this.transactions[i].inRate
        );
        if (this.transactions[i].isExclusion === 1) {
          row.push("제외");
        }
        jsonData.push(row);
      }
      {
        let row = [];
        row.push("합계");
        if (this.$store.state.auth.user.isAdmin >= 1) {
          row.push("");
        }
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push("");
        row.push(this.totalAmount.usdAmount);
        row.push(this.totalAmount.jpyAmount);
        row.push(this.totalAmount.twdAmount);
        row.push(this.totalAmount.cnyAmount);
        row.push(this.totalAmount.eurAmount);
        row.push("");
        row.push("");
        row.push(this.totalAmount.krwAmount);
        row.push("");
        jsonData.push(row);
      }
      export_json_to_excel(th, jsonData, "tablePrint");
    },

    exportUniqueExcel() {
      const th = ["날짜", "이름", "실명번호", "국적", "구분"];
      const jsonData = [];
      const uniqueSet = new Set();
      
      for (let i = 0; i < this.transactions.length; i++) {
        const trans = this.transactions[i];

        // 1. 제외 항목 건너뛰기
        if (trans.isExclusion === 1) {
          continue;
        }

        const uniqueDate = this.$h.formatDate(trans.updatedAt, "YYYY-MM-DD");
        const displayDate = this.$h.formatDate(trans.updatedAt, "MM/DD");
        
        // 2. 이름 추출 및 좌우 공백 제거
        const name = trans.user.name ? String(trans.user.name).trim() : "";

        // 3. 실명번호 추출 및 좌우 공백 제거
        let realNameNo = "";
        if (trans.user.noType == 1 && trans.user.residenceNo) {
          realNameNo = String(trans.user.residenceNo).trim();
        } else if (trans.user.noType == 2 && trans.user.passportNo) {
          realNameNo = String(trans.user.passportNo).trim();
        } else if (trans.user.noType == 3 && trans.user.foreignResidenceNo) {
          realNameNo = String(trans.user.foreignResidenceNo).trim();
        } else if (trans.user.noType == 4 && trans.user.others) {
          realNameNo = String(trans.user.others).trim();
        }

        // 4. 이름이나 실명번호가 아예 없는 경우 건너뛰기
        if (!name || !realNameNo) {
          continue;
        }

        // 5. 이름 특수문자 및 숫자 체크 (하이픈 '-'은 허용)
        const invalidNameRegex = /[^\p{L}\s-]/u;
        if (invalidNameRegex.test(name)) {
          continue;
        }

        // 6. 실명번호 하이픈(-) 모두 제거하여 정규화
        const normalizedRealNameNo = realNameNo.replace(/-/g, "");

        // ⭐ 6-1. 주민등록번호(1) 또는 외국인등록번호(3) 길이 검증
        // 하이픈 제거 후 정확히 13자리가 아니면(초과하거나 부족하면) 건너뜀
        if (trans.user.noType == 1 || trans.user.noType == 3) {
          if (normalizedRealNameNo.length !== 13) {
            continue;
          }
        }

        const nationality = trans.user.nationality || "";

        // 7. 중복 체크용 키 생성 (날짜_이름_하이픈제거된실명번호)
        const uniqueKey = `${uniqueDate}_${name}_${normalizedRealNameNo}`;

        // 8. 중복 검사 및 데이터 푸시
        if (!uniqueSet.has(uniqueKey)) {
          uniqueSet.add(uniqueKey);
          jsonData.push([
            displayDate,
            name,
            normalizedRealNameNo, // 엑셀 출력 시에도 하이픈 제거된 값으로 통일
            nationality,
            "0" + trans.user.noType // 구분(01주민/02여권/03외국인/04기타)
          ]);
        }
      }

      // 추출할 데이터가 없는 경우 예외 처리
      if (jsonData.length === 0) {
        Toastify({
          text: "출력할 데이터가 없습니다.",
          duration: 3000,
          newWindow: true,
          close: true,
          gravity: "top",
          position: "right",
          backgroundColor: "#e53231",
          stopOnFocus: true
        }).showToast();
        return;
      }

      // 엑셀 다운로드 실행
      export_json_to_excel(th, jsonData, "Unique_Users_Print");
    }
  }
};
</script>
